import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  ma: undefined, // required - Mã phương thức
  ten: undefined, // required - Tên phương thức
  // required - Thông tin hiệu lực
  hieu_luc: {
    an: undefined, // required - Cho biết có ẩn hiển thị không
    tu: undefined, // optional - Có hiệu lực từ
    den: undefined, // optional - Có hiện lực đến
  },
};

// validation form
model.validForm = {
  tieu_de: [ValidService.required, ValidService.checkSpaceString],
  phan_loai: [ValidService.required, ValidService.requiredChange],
  noi_dung: [ValidService.required], // required Giá trị hệ số
  hien_thi: [], // required Đã bị khóa chưa
};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "ten",
  defaultSort: ["ten", "ascending"],
  filters: "",
  recordSelected: [],

  dataSearch: {
    value: {
      ten: "",
      ma: "",
      "hieu_luc.an": "",
    },
    valid: {
      ten: [],
      "hieu_lu.tu": [],
      "hieu_luc.den": []
    },
    operator: {
      ten: ":regex_i:",
      ma: ":regex_i:",
      "hieu_luc.an": "",
    },
  },
};

export default model;
